export interface FanDto {
  fanId: number;
  email: string;
}

export class Fan {
  id: number;
  email: string;

  constructor(dto: FanDto) {
    this.id = dto.fanId;
    this.email = dto.email;
  }
}
